export default {
  wrap       : true,
  allowInput : true,
  dateFormat : 'm/d/Y'
}